import { useEffect, useState } from 'react';

import { useGlobalContext } from '../../contexts';
import { Svg } from '../Svg';

export function Drawer() {
  const {
    state: { drawer },
    actions: { closeDrawer },
  } = useGlobalContext();

  const [animateIn, setAnimateIn] = useState(true);

  useEffect(() => {
    setAnimateIn(true);
  }, [drawer]);

  const { className, ...props } = { ...drawer.props };

  return drawer.children ? (
    <div
      className={`
        fixed bottom-0 right-0 top-0 z-50 w-[calc(100%-2rem)] max-w-[48rem] overflow-hidden bg-background ${className}
        ${animateIn ? 'animate-slideIn' : ''}
      `}
      onAnimationEnd={() => setAnimateIn(false)}
      {...props}
    >
      <div className="flex h-full flex-col overflow-y-auto px-4 py-[46px] scrollbar-hide lg:px-[46px]">
        <div className="absolute right-0 top-0 md:right-5 md:top-5 z-10">
          <button
            aria-label="Close drawer"
            className="right-[18px] top-[96px] z-10 flex h-[46px] w-[46px] items-center justify-center bg-transparent lg:right-[120px] lg:top-[127px]"
            onClick={closeDrawer}
            type="button"
          >
            <Svg
              className="w-6 text-text"
              src="/svgs/close.svg#close"
              title="Close"
              viewBox="0 0 24 24"
            />
          </button>
        </div>
        <div className="flex-grow">{drawer.children}</div>
      </div>
    </div>
  ) : null;
}

Drawer.displayName = 'Drawer';
